import { render, staticRenderFns } from "./Categorias-de-inventario.vue?vue&type=template&id=3689b974&scoped=true"
import script from "./Categorias-de-inventario.vue?vue&type=script&lang=js"
export * from "./Categorias-de-inventario.vue?vue&type=script&lang=js"
import style0 from "./Categorias-de-inventario.vue?vue&type=style&index=0&id=3689b974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3689b974",
  null
  
)

export default component.exports